import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { TargetIcon, CrosshairIcon, CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 relative overflow-hidden" data-id="element-206">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-trading-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-207" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-208">
        <div className="max-w-4xl mx-auto" data-id="element-209">
          <div className="text-center mb-16" data-id="element-210">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="inline-flex items-center justify-center p-4 bg-trading-gold/10 rounded-full mb-6 text-trading-gold" data-id="element-211">
              <TargetIcon className="w-10 h-10" data-id="element-212" />
            </motion.div>
            <h2 className="text-4xl md:text-5xl font-heading text-white mb-6" data-id="element-213">
              Presentamos el{' '}
              <span className="text-gradient-gold" data-id="element-214">
                Protocolo de "Vela Única"
              </span>
            </h2>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-215">
              Este sistema no se basa en adivinar a dónde irá el precio, sino en
              identificar dónde está atrapada la liquidez institucional.
            </p>
          </div>

          <Card className="border-trading-gold/30 bg-gradient-to-b from-trading-card to-trading-dark p-8 md:p-12 mb-16 relative overflow-hidden" data-id="element-216">
            <div className="absolute top-0 right-0 w-64 h-64 bg-trading-gold/10 rounded-full blur-[80px] -mr-32 -mt-32" data-id="element-217" />

            <p className="text-lg text-slate-300 leading-relaxed relative z-10 mb-8" data-id="element-218">
              En lugar de estar horas analizando, esperamos el cierre de la
              primera vela de 5 minutos (9:35 AM EST). Identificamos la
              manipulación, entramos en el retroceso técnico y cerramos la
              plataforma.
            </p>

            <div className="bg-trading-green/10 border border-trading-green/20 rounded-lg p-6 flex items-start gap-4 relative z-10" data-id="element-219">
              <CheckCircle2Icon className="w-8 h-8 text-trading-green flex-shrink-0" data-id="element-220" />
              <p className="text-white font-medium text-lg" data-id="element-221">
                Si el movimiento se da, ya tienes tu profit del día. Si no,
                cierras con una pérdida mínima controlada y lo intentas mañana.
              </p>
            </div>
          </Card>

          <h3 className="text-3xl font-heading text-center mb-10" data-id="element-222">
            Cómo Funciona en 3 Pasos
          </h3>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-223">
            {[{
            step: '1',
            title: 'Identifica',
            desc: 'Marca los niveles de liquidez de Londres y el día anterior.',
            icon: <CrosshairIcon className="w-6 h-6" data-id="element-224" />
          }, {
            step: '2',
            title: 'Espera',
            desc: 'Deja que la apertura de las 9:30 AM limpie a los traders impacientes.',
            icon: <ClockIcon className="w-6 h-6" data-id="element-225" />
          }, {
            step: '3',
            title: 'Ejecuta',
            desc: 'Entra en el Fair Value Gap confirmado y retírate con tu ganancia o pérdida controlada.',
            icon: <TargetIcon className="w-6 h-6" data-id="element-226" />
          }].map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.2
          }} className="bg-trading-card border border-white/5 rounded-xl p-6 relative group hover:border-trading-gold/30 transition-colors" data-id="element-227">
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-trading-gold text-trading-dark font-heading font-bold text-xl rounded-lg flex items-center justify-center shadow-lg" data-id="element-228">
                  {item.step}
                </div>
                <div className="mt-4 mb-4 text-trading-gold bg-trading-gold/10 w-12 h-12 rounded-lg flex items-center justify-center" data-id="element-229">
                  {item.icon}
                </div>
                <h4 className="text-xl font-heading text-white mb-3" data-id="element-230">
                  {item.title}
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-231">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}
// Need to import ClockIcon for the array above
import { ClockIcon } from 'lucide-react';